import type {
  RestrictedWord,
  RestrictedWordLogsResponse,
  RestrictedWordsSettings,
  UpdateRestrictedWordsPayload,
} from '@/modules/restricted-words/types.ts'
import { apiClient } from '@/utils/axios.ts'

const toggleRestrictedWordsActivation = async (state: boolean) => {
  const response = await apiClient.post(
    `/restricted-word-settings/toggle/${state}`,
  )

  return response.data
}

const getRestrictedWordsSettings =
  async (): Promise<RestrictedWordsSettings> => {
    const response = await apiClient.get<RestrictedWordsSettings>(
      '/restricted-word-settings',
    )

    return response.data
  }

const updateRestrictedWordsSettings = async (
  settings: Partial<UpdateRestrictedWordsPayload>,
) => {
  const response = await apiClient.post(`/restricted-word-settings`, settings)

  return response.data
}

const getRestrictedWordsLogs = async ({
  page,
  size,
  memberId,
  creatorId,
  word,
  fromDate,
  endDate,
}: {
  size: number
  page: number
  creatorId?: string
  memberId?: string
  word?: string
  fromDate?: string
  endDate?: string
}) => {
  const response = await apiClient.get<RestrictedWordLogsResponse>(
    '/restricted-word-logs',
    {
      params: {
        senderId: memberId,
        creatorId,
        page,
        size,
        word: word || undefined,
        fromDate,
        endDate,
      },
    },
  )

  return response.data
}

const getRestrictedWords = async () => {
  const response = await apiClient.get<RestrictedWord[]>('/restricted-words')

  return response.data
}

const addRestrictedWord = async (
  word: string,
  blockAllCombinations: boolean,
) => {
  const response = await apiClient.post('/restricted-words', {
    word,
    blockAllCombination: blockAllCombinations,
  })

  return response.data
}

const overrideRestrictedWord = async (
  wordId: number,
  disabled: boolean,
  overriddenBlockAllCombination?: boolean,
) => {
  const response = await apiClient.put(`/restricted-words/${wordId}/override`, {
    disabled,
    overriddenBlockAllCombination,
  })

  return response.data
}

const editRestrictedWord = async (body: Partial<RestrictedWord>) => {
  const response = await apiClient.put(`/restricted-words/${body.id}`, body)

  return response.data
}

const deleteRestrictedWord = async (id: number) => {
  const response = await apiClient.delete(`/restricted-words/${id}`)

  return response.data
}

export const restrictedWordsService = {
  toggleRestrictedWordsActivation,
  getRestrictedWordsSettings,
  updateRestrictedWordsSettings,
  getRestrictedWordsLogs,
  getRestrictedWords,
  addRestrictedWord,
  overrideRestrictedWord,
  editRestrictedWord,
  deleteRestrictedWord,
}
